"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _newComponents = require("../new-components");
var getText = function getText(addText, added, soldOut) {
  var text = addText || 'Book Now';
  if (soldOut) {
    text = 'Sold out';
  }
  if (added) {
    text = 'Booked';
  }
  return text;
};
var ExtrasBox = function ExtrasBox(_ref) {
  var title = _ref.title,
    description = _ref.description,
    imageUrl = _ref.imageUrl,
    addText = _ref.addText,
    priceText = _ref.priceText,
    added = _ref.added,
    soldOut = _ref.soldOut,
    maxPerEntity = _ref.maxPerEntity,
    disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement(_newComponents.Card, {
    template: "ImageCard",
    imageCardTemplate: "VerticalSplit",
    disabled: disabled,
    image: {
      url: imageUrl ? imageUrl : 'https://assets.theyachtweek.com/wp-content/uploads/2023/03/new-TYW_-Croatia_w34_Tam_Koppelaar-140.jpg',
      alt: title
    },
    title: title
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-column justify-between height-100%"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-md d8-u-color-primary"
  }, getText(addText, added, soldOut)), priceText !== undefined && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-font-size-base"
  }, "Price: ", priceText), !!maxPerEntity && /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm d8-u-color-contrast-high"
  }, "Max ", maxPerEntity, " per booking")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-color-contrast-high d8-u-text-bold d8-u-ls-sm padding-top-sm"
  }, description))));
};
ExtrasBox.propTypes = {
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].any.isRequired,
  imageUrl: _propTypes["default"].string.isRequired,
  addText: _propTypes["default"].string,
  priceText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  added: _propTypes["default"].bool,
  soldOut: _propTypes["default"].bool,
  maxPerEntity: _propTypes["default"].number
};
var _default = exports["default"] = ExtrasBox;